// LIBRARIES

import styled from "styled-components";

// MISC
import {
  BORDER_RADIUS,
  COLORS,
  DEVICE_SIZE,
  DEVICE_TYPE,
  MARGIN,
  SIZE,
} from "constants/variables";

//ASSETS
import cursorIcon from "assets/img/Cursor.png";

export const AgendaContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 162px ${MARGIN.max230} ${SIZE.max100} ${MARGIN.max230};
  justify-content: center;
  align-items: center;
  gap: ${MARGIN.fix24};
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    width: 100%;
    padding: ${MARGIN.fix150} ${MARGIN.fix24} ${MARGIN.max120} ${MARGIN.fix24};
  }
`;

export const BodyContainer = styled.div`
  width: 100%;
  max-width: 1464px;
  min-width: 760px;
  border-radius: ${BORDER_RADIUS.radius24};
  background-color: ${COLORS.Cultured};
  padding: ${MARGIN.max40};
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: ${DEVICE_SIZE.TABLET_MAX}) {
    padding: ${MARGIN.fix24};
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    min-width: 0px;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  gap: ${MARGIN.fix16};
  justify-content: flex-start;
  align-items: center;
  margin-bottom: ${MARGIN.max20};
`;

export const BodyContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${MARGIN.max24};
`;

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${MARGIN.max10};
  width: 100%;
  max-width: 1464px;
  min-width: 760px;
  margin-top: 14px;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    min-width: 0px;
    margin-left: ${MARGIN.max24};
  }
`;

export const TopSectionHeader = styled.div`
  width: 240px;
  height: 23px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${MARGIN.max8};
  opacity: 0.5;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  transition: 0.3s ease-in-out;
  &:hover {
    opacity: 0.8;
    transition: 0.3s ease-in-out;
  }
`;

export const BackIcon = styled.img`
  width: 10px;
  height: 16px;
`;
